<script>
//部门类型 农场类型
const DEPT_CATEGORY_FRAM='5';

//部门类型 农场类型/服务部
const DEPT_CATEGORY_FRAM_FUWUBU='2,5';
  export default
  {
    DEPT_CATEGORY_FRAM,
    DEPT_CATEGORY_FRAM_FUWUBU,
    
  }
</script>